export function Field({ label, id, hint, className = "", ...props }) {
  return (
    <div className="space-y-1.5">
      <label htmlFor={id} className="font-display text-sm font-medium">
        {label}
      </label>
      <input id={id} className={`field w-full h-12 px-4 text-base ${className}`} {...props} />
      {hint && <p className="text-xs text-[var(--yarn-muted)]">{hint}</p>}
    </div>
  );
}

export function Section({ label, hint, children }) {
  return (
    <div className="space-y-2">
      <p className="font-display text-sm font-medium">{label}</p>
      {children}
      {hint && <p className="text-xs text-[var(--yarn-muted)]">{hint}</p>}
    </div>
  );
}

export function ChipGroup({ options, value, onChange, testid, disabled }) {
  return (
    <div className="flex flex-wrap gap-2" role="radiogroup">
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          role="radio"
          aria-checked={value === o.value}
          data-active={value === o.value}
          disabled={disabled || o.disabled}
          onClick={() => onChange(o.value)}
          className="chip h-10 px-4 text-sm"
          data-testid={`${testid}-${o.value}`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
